(() => {
  const hoverPointer = window.matchMedia('(any-hover: hover) and (any-pointer: fine)');
  const timers = new WeakMap();
  let keyboardNavigation = false;
  const groups = () => document.querySelectorAll('.ux-nav__group');
  const cancelClose = group => {
    clearTimeout(timers.get(group));
    timers.delete(group);
  };
  const close = group => {
    cancelClose(group);
    group.open = false;
  };
  const desktopGroup = target => target instanceof Element
    ? target.closest('.ux-nav--desktop .ux-nav__group') : null;

  document.addEventListener('keydown', event => {
    if (event.key === 'Tab') keyboardNavigation = true;
    if (event.key !== 'Escape') return;
    const focusedGroup = document.activeElement?.closest('.ux-nav__group[open]');
    const openGroups = document.querySelectorAll('.ux-nav__group[open]');
    const returnFocus = focusedGroup || openGroups[0];
    openGroups.forEach(close);
    returnFocus?.querySelector('summary')?.focus();
  });
  document.addEventListener('pointerdown', () => { keyboardNavigation = false; });
  document.addEventListener('click', event => {
    document.querySelectorAll('.ux-nav--desktop .ux-nav__group[open]').forEach(group => {
      if (!group.contains(event.target)) close(group);
    });
  });
  document.addEventListener('toggle', event => {
    const group = event.target;
    if (!(group instanceof Element) || !group.matches('.ux-nav__group') || !group.open) return;
    group.closest('.ux-nav').querySelectorAll('.ux-nav__group').forEach(other => {
      if (other !== group) close(other);
    });
  }, true);
  document.addEventListener('pointerover', event => {
    if (event.pointerType !== 'mouse' || !hoverPointer.matches) return;
    const group = desktopGroup(event.target);
    if (!group || !group.querySelector('.ux-nav__children a')) return;
    cancelClose(group);
    if (group.contains(event.relatedTarget)) return;
    group.closest('.ux-nav').querySelectorAll('.ux-nav__group[open]').forEach(other => {
      if (other !== group) close(other);
    });
    group.open = true;
  });
  document.addEventListener('pointerout', event => {
    if (event.pointerType !== 'mouse' || !hoverPointer.matches) return;
    const group = desktopGroup(event.target);
    if (!group || group.contains(event.relatedTarget)) return;
    cancelClose(group);
    timers.set(group, setTimeout(() => {
      if (!keyboardNavigation || !group.contains(document.activeElement)) close(group);
    }, 200));
  });
  document.addEventListener('focusout', event => {
    const group = desktopGroup(event.target);
    if (group && !group.contains(event.relatedTarget)) close(group);
  });
})();
